<footer>
  @if (showTopFooter) {
    <div class="top-footer">
      <!-- Grid container -->
      <div class=" container p-4">
        <!--Grid row-->
        <div class="row">
          <!--Grid column-->
          <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
            <h5 class="text-uppercase">Footer Content</h5>
            <ul class="list-unstyled mb-0">
              <li>
                <a routerLink="./" class="">Lorem ipsum</a>
              </li>
              <li>
                <a routerLink="./" class="">Ut facilisis</a>
              </li>
              <li>
                <a routerLink="./" class="">Aenean sit</a>
              </li>
            </ul>
          </div>
          <!--Grid column-->
          <!--Grid column-->
          <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
            <h5 class="text-uppercase">Footer Content</h5>
            <ul class="list-unstyled mb-0">
              <li>
                <a routerLink="./" class="" role="link" tabindex="0">Suspendisse potenti</a>
              </li>
            </ul>
          </div>
          <!--Grid column-->
          <!--Grid column-->
          <div class="col-lg-4 col-md-12 mb-4 mb-md-0">
            <h5 class="text-uppercase">Footer Content</h5>
            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iste atque ea quis
              molestias. Fugiat pariatur maxime quis culpa corporis vitae repudiandae aliquam
              voluptatem veniam, est atque cumque eum delectus sint!
            </p>
          </div>
          <!--Grid column-->
        </div>
        <!--Grid row-->
      </div>
    </div>
  }
  <!-- Grid container -->

  <!-- Copyright -->
  <!-- ORIGINAL CODE - COMMENTED OUT FOR REFERENCE
  <div class="bottom-footer p-1 d-flex flex-column flex-md-row justify-content-between align-items-center text-white">
    <div class="content-container align-self-center">
      <ul class="footer-info list-unstyled d-flex justify-content-center mb-0">
      <li>
        <a class="btn text-white" href="https://www.twc.edu.hk/en/disclaimer">Disclaimer</a>
      </li>
      <li>
        <a class="btn text-white" href="https://www.twc.edu.hk/en/privacy">Privacy Policy</a>
      </li>
      <li>
        <a class="btn text-white" href="https://www.twc.edu.hk/en/accessibility">Accessibility Statement</a>
      </li>
      <li>
        <a class="btn text-white" href="https://www.twc.edu.hk/en/sitemap">Site Map</a>
      </li>
      </ul>
    </div>
    <div class="contact-info align-self-center ms-md-auto">
      ©2025 Tung Wah College Limited. All Rights Reserved.
    </div>
    <div class="contact-info align-self-center ms-md-auto">
      <table><tr><td><span class="text-white">Contact TWC Library</span></td></tr><tr><td><span class="text-white">Tel: 3190 6650</span></td></tr><tr><td><span class="text-white">Email: lib&#64;twc.edu.hk</span></td></tr></table>
    </div>
    @if (coarLdnEnabled$ | async) {
      <div class="notify-enabled text-white align-self-end">
        <a class="coar-notify-support-route" routerLink="info/coar-notify-support" role="link" tabindex="0">
          <img class="n-coar" src="assets/images/n-coar.svg" [attr.alt]="'menu.header.image.logo' | translate" />
          {{ 'footer.link.coar-notify-support' | translate }}
        </a>
      </div>
    }
  </div>
  END ORIGINAL CODE -->

  <!-- IMPROVED FOOTER - NEW DESIGN -->
  <div class="bottom-footer py-4 px-4 text-white">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-center gx-4">
        <!-- Footer Links -->
        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
          <ul class="footer-info list-unstyled d-flex flex-wrap justify-content-center align-items-center mb-0" style="gap: 0.5rem;">
            <li>
              <a class="btn btn-link text-white px-2 py-1" href="https://twc-hk.libguides.com/institutional-repository" target="_blank" rel="noopener noreferrer" style="font-size: 0.9rem;">Repository User Guide</a>
            </li>
            <li class="text-white-50">|</li>
            <li>
              <a class="btn btn-link text-white px-2 py-1" href="https://www.twc.edu.hk/en/disclaimer" target="_blank" rel="noopener noreferrer" style="font-size: 0.9rem;">Disclaimer</a>
            </li>
            <li class="text-white-50">|</li>
            <li>
              <a class="btn btn-link text-white px-2 py-1" href="https://www.twc.edu.hk/en/privacy" target="_blank" rel="noopener noreferrer" style="font-size: 0.9rem;">Privacy Policy</a>
            </li>
            <li class="text-white-50">|</li>
            <li>
              <a class="btn btn-link text-white px-2 py-1" href="https://www.twc.edu.hk/en/accessibility" target="_blank" rel="noopener noreferrer" style="font-size: 0.9rem;">Accessibility Statement</a>
            </li>
            <li class="text-white-50">|</li>
            <li>
              <a class="btn btn-link text-white px-2 py-1" href="https://www.twc.edu.hk/en/sitemap" target="_blank" rel="noopener noreferrer" style="font-size: 0.9rem;">Site Map</a>
            </li>
          </ul>
        </div>

        <!-- Vertical Divider (Desktop only) -->
        <div class="col-auto d-none d-lg-block px-2">
          <div class="border-start border-secondary" style="height: 50px;"></div>
        </div>

        <!-- Contact Information -->
        <div class="col-12 col-lg-auto">
          <div class="d-flex flex-column flex-md-row justify-content-center align-items-center text-center gap-3">
            <!-- Copyright -->
            <div class="d-flex align-items-center">
              <small style="font-size: 0.85rem; white-space: nowrap;">©{{ dateObj | date:'yyyy' }} Tung Wah College Limited. All Rights Reserved.</small>
            </div>
            
            <!-- Contact Details -->
            <div class="contact-details d-flex flex-column justify-content-center text-center text-md-start">
              <div class="mb-1" style="font-size: 0.9rem;"><strong>Contact TWC Library</strong></div>
              <div style="font-size: 0.85rem;">Tel: 3190 6650</div>
              <div style="font-size: 0.85rem;">Email: <a href="mailto:lbresearch&#64;twc.edu.hk" class="text-white text-decoration-none">lbresearch&#64;twc.edu.hk</a></div>
            </div>
          </div>
        </div>
      </div>

      <!-- COAR Notify Support (if enabled) -->
      @if (coarLdnEnabled$ | async) {
        <div class="row mt-3">
          <div class="col-12 text-center">
            <div class="notify-enabled">
              <a class="coar-notify-support-route text-white text-decoration-none" routerLink="info/coar-notify-support" role="link" tabindex="0">
                <img class="n-coar me-2" src="assets/images/n-coar.svg" [attr.alt]="'menu.header.image.logo' | translate" style="height: 20px;" />
                {{ 'footer.link.coar-notify-support' | translate }}
              </a>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <!-- Copyright -->
</footer>